// extracted by mini-css-extract-plugin
export default {"modal":"kGPmEOT79dzICCxWPR6Q__modal___"};